import React from 'react';
import { Link } from 'react-router-dom';

export function PublicNav() {
  return (
    <section className="navbar-area navbar-nine">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <nav className="navbar navbar-expand-lg">
              <Link to="/" className="navbar-brand">
                <img src="/assets/images/white-logo.svg" alt="BLRC" />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNine"
                aria-controls="navbarNine"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="toggler-icon" />
                <span className="toggler-icon" />
                <span className="toggler-icon" />
              </button>
              <div className="collapse navbar-collapse sub-menu-bar" id="navbarNine">
                <ul className="navbar-nav me-auto">
                  <li className="nav-item">
                    <Link to="/" className="page-scroll">Home</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/#AboutUs" className="page-scroll">About Us</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/#services" className="page-scroll">Services</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/#WhyChoose" className="page-scroll">Why Choose Us?</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/#contact" className="page-scroll">Contact</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/blog" className="page-scroll active">Blog</Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </section>
  );
}

export function PublicFooter() {
  return (
    <footer className="footer-area footer-eleven">
      <div className="footer-top">
        <div className="container">
          <div className="inner-content">
            <p className="copyright-text">© 2025 BLRC All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function BlogBanner({ title, summary }) {
  return (
    <section className="blog-header" style={{
      background: 'linear-gradient(135deg, #a68947 0%, #634f23 100%)',
      paddingTop: '150px',
      paddingBottom: '72px',
      color: '#fff',
    }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center">
            <p style={{ letterSpacing: '0.14em', textTransform: 'uppercase', fontSize: '13px', marginBottom: '12px', opacity: 0.85, color: '#fff' }}>
              Case studies
            </p>
            <h1 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 700, marginBottom: '16px', lineHeight: 1.2, color: '#fff' }}>
              {title}
            </h1>
            {summary ? (
              <p style={{ fontSize: '1.05rem', opacity: 0.92, maxWidth: '680px', margin: '0 auto', lineHeight: 1.6, color: '#fff' }}>
                {summary}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
